import { AxiosResponse } from "axios";
import {
	dataMigrationInstance,
	dcsInstance,
	instance,
	orionInstance,
} from "../config/Axios";

// get all clients
export const getClientAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetClientAllAsync");
};

// retrieve all modules
export const getModuleAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetModuleAllAsync");
};

// add a client
export const postClientAsync = async (): // client data goes here
Promise<AxiosResponse> => {
	return await instance.post("/AddClientAsync");
};

// get client types
export const getClientTypeAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetClientTypeAllAsync");
};

// get client modules
export const getClientModuleAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetClientModuleAllAsync");
};

// get client modules by id (FLAG)
export const getClientModuleByIdAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetClientModuleByIdAsync");
};

// get client module options
export const getClientModuleOptionAllAsync =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/GetClientModuleOptionAllAsync");
	};

// get client module options (intellicaAdmins)
export const getClientModuleOptionByUserClientIds =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/api/ClientModuleOption/GetAllByUserClientIds");
	};

// get module options
export const getModuleOptionAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetModuleOptionAllAsync");
};

// get client email domains
export const getClientEmailDomainAllAsync =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/GetClientEmailDomainAllAsync");
	};

// get client admin systems
export const getClientAdminSystemAllAsync =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/GetClientAdminSystemAllAsync");
	};

// get all users
export const getUserAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetUserAllAsync");
};

// get user by client id
export const getUserByIdAsyncClient = async (
	clientId: string,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/GetUserByClientIdAsync?clientId=${encodeURIComponent(clientId)}`,
	);
};

export const getUserByIdAsyncScheme = async (
	schemeId: string,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/GetUserBySchemeIdAsync?schemeId=${encodeURIComponent(schemeId)}`,
	);
};

// get scheme types
export const getSchemeTypeAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetSchemeTypeAllAsync");
};

// get scheme
export const getSchemeAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetSchemeAllAsync");
};

export const getSchemeBySchemeIdAsync = async (
	schemeId: string,
): Promise<AxiosResponse> => {
	return await instance.get(`/api/Scheme/GetById?schemeId=${schemeId}`);
};

export const getSchemeByClientIdAsync = async (
	clientId: number,
): Promise<AxiosResponse> => {
	return await instance.get(`/GetSchemeByClientIdAsync?clientId=${clientId}`);
};

export const getSchemeByIdAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetSchemeByIdAsync");
};

// add a scheme
export const addSchemeAsync = async (): Promise<AxiosResponse> => {
	return await instance.post("/AddSchemeAsync");
};

// update scheme details
export const updateSchemeAsync = async (): Promise<AxiosResponse> => {
	return await instance.post("/UpdateSchemeAsync");
};

// delete a scheme
export const deleteSchemeAsync = async (): Promise<AxiosResponse> => {
	return await instance.delete("/DeleteSchemeAsync");
};

// add a scheme email Domain
export const addSchemeEmailDomainAsync = async (): Promise<AxiosResponse> => {
	return await instance.post("/AddSchemeEmailDomainAsync");
};

// update a scheme email Domain
export const updateSchemeEmailDomainAsync =
	async (): Promise<AxiosResponse> => {
		return await instance.put("/UpdateSchemeEmailDomainAsync");
	};

// get all scheme modules
export const getSchemeModuleAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetSchemeModuleAllAsync");
};

export const getSchemeModuleBySchemeIdAsync = async (
	schemeId: number,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/GetSchemeModuleBySchemeIdAsync?schemeId=${schemeId}`,
	);
};

export const getSchemeModuleByIdAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetSchemeModuleByIdAsync");
};

export const deleteSchemeModuleAsync = async (id: number, schemeId: number): Promise<AxiosResponse> => {
	return await instance.delete(`/DeleteSchemeModuleAsync?id=${id}&schemeId=${schemeId}`);
};

// get all scheme module options
export const getSchemeModuleOptionAllAsync =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/GetSchemeModuleOptionAllAsync");
	};

export const getSchemeModuleOptionBySchemeIdAsync = async (
	schemeId: number,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/GetSchemeModuleOptionBySchemeIdAsync?schemeId=${schemeId}`,
	);
};

export const deleteSchemeModuleOptionAsync = async (id: number, schemeId: number): Promise<AxiosResponse> => {
	return await instance.delete(`/DeleteSchemeModuleOptionAsync?id=${id}&schemeId=${schemeId}`);
};

// get all scheme module options
export const getSchemeAdminSystemAllAsync =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/GetSchemeAdminSystemAllAsync");
	};

export const getSchemeAdminSystemByClientIdAsync = async (
	clientId: number,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/GetSchemeAdminSystemByClientIdAsync?clientId=${clientId}`,
	);
};

export const getSchemeAdminSystemBySchemeIdAsync = async (
	schemeId: number,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/GetSchemeAdminSystemBySchemeIdAsync?schemeId=${schemeId}`,
	);
};

export const getClientWithConfigByIdAsync = async (
	clientId: number,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/GetClientWithConfigByIdAsync?clientId=${clientId}`,
	);
};

export const getClientWithConfigAllAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetClientWithConfigAllAsync");
};

export const getClientWithConfigByUserIds =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/api/ClientWithConfig/GetAllByUserClientIds");
	};

export const updateClientStatusAsync = async (
	clientId: number,
	clientStatusId: string | undefined
): Promise<AxiosResponse> => {
	return await instance.post(
		`/UpdateClientStatusAsync?clientId=${clientId}&clientStatusId=${clientStatusId}`,
	);
};

export const updateSchemeStatusAsync = async (
	schemeId: number,
	schemeStatusId: string | undefined
): Promise<AxiosResponse> => {
	return await instance.put(
		`/UpdateSchemeStatusAsync?schemeId=${schemeId}&schemeStatusId=${schemeStatusId}`,
	);
};

export const getContainerContainsAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetSchemeModuleAllAsync");
};

export const getCurrentUserAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetCurrentUserAsync");
};

export const getModuleOptionAllHierarchicalAsync =
	async (): Promise<AxiosResponse> => {
		return await instance.get("/GetModuleOptionAllHierarchicalAsync");
	};

export const getMembershipStatusAll = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetMembershipStatusAll");
};

export const getSeverityAll = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetSeverityAll");
};

export const getCriticalDataItemAll = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetCriticalDataItemAll");
};

export const getRunInstanceRerunConfigurationAsync = async (schemeId: number, runInstanceId: number): Promise<AxiosResponse> => {
	return await instance.get(`/GetRunInstanceRerunConfigurationAsync?runInstanceId=${runInstanceId}&schemeId=${schemeId}`);
};

export const getDataAuditDashboardLinks = async (
	schemeId: number,
	moduleOptionId: number,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/api/DashboardLink/GetBySchemeIdModuleOptionId?schemeId=${schemeId}&moduleOptionId=${moduleOptionId}`,
	);
};

export const getDataAuditDashboardCode = async (
	schemeId: number,
	moduleOptionId: number,
	dashboardCode: string,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/api/DashboardLink/${dashboardCode}/embed?schemeId=${schemeId}&moduleOptionId=${moduleOptionId}`,
	);
};

export const getByModuleOptionIdsSchemeIdAsync = async (
	moduleOptionIds: number[],
	schemeId: number,
): Promise<AxiosResponse> => {
	return await instance.get(
		`/api/DVCModuleOption/GetByModuleOptionIdsSchemeIdAsync?${moduleOptionIds
			.map((id) => `moduleOptionIds=${id}`)
			.join("&")}&schemeId=${schemeId}`,
	);
};

export const getAllDefaultDvcsAsync = async (): Promise<AxiosResponse> => {
	return await instance.get("/GetDefaultDataAsync");
};

export const updateByModuleOptionAndClientAsync = async (
	moduleOptionId: number,
	clientId: number,
	dvcIds: number[],
): Promise<AxiosResponse> => {
	return await instance.post(
		`/UpdateByModuleOptionAndClientAsync?moduleOptionId=${moduleOptionId}&clientId=${clientId}&dvcIds=${dvcIds.join(",")}`,
		null,
	);
};

export const getAllClientDvcsAsync = async (
	clientId: number,
): Promise<AxiosResponse> => {
	return await instance.get(`/GetByClientIdAsync?clientId=${clientId}`);
};

export const updateByModuleOptionAndSchemeAsync = async (
	moduleOptionId: number,
	schemeId: number,
	dvcIds: number[],
): Promise<AxiosResponse> => {
	return await instance.post(
		`/UpdateByModuleOptionAndSchemeAsync?moduleOptionId=${moduleOptionId}&schemeId=${schemeId}&dvcIds=${dvcIds.join(",")}`,
		null,
	);
};

export const getBySchemeIdAsync = async (
	schemeId: number,
): Promise<AxiosResponse> => {
	return await instance.get(`/GetBySchemeIdAsync?schemeId=${schemeId}`);
};

export const memberDataBulkInsertFromExcelAsync = async (
	formData: FormData,
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	return instance.post(
		`/MemberDataBulkInsertFromExcelAsync?clientId=${clientId}&schemeId=${schemeId}`,
		formData,
	);
};

export const getDataAuditReport = async (
	schemeId: number,
): Promise<AxiosResponse> => {
	return instance.get(`/api/DataAuditReport/${schemeId}`);
};

export const getReportDoc = async (
	schemeIdContext: number,
	returnedReportId: string | undefined,
): Promise<AxiosResponse> => {
	return instance.get(
		`/api/DataAuditReport/${schemeIdContext}/${returnedReportId}`,
		{
			headers: {
				Accept: "application/octet-stream",
			},
			responseType: "blob",
		},
	);
};

export const getDataAuditReportResponse = async (
	schemeId: number,
	runInstanceId: any,
): Promise<AxiosResponse> => {
	return instance.post(`/api/DataAuditReport/${schemeId}`, runInstanceId);
};

export const getEqualisationResults = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardOneAsync?schemeId=${encodeURIComponent(schemeId)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getFiveYearProjection = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardTwoAsync?schemeId=${encodeURIComponent(schemeId)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getLiability = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardThreeAsync?schemeId=${encodeURIComponent(
			schemeId,
		)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getTotalPension = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardFourAsync?schemeId=${encodeURIComponent(
			schemeId,
		)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getTotalBackPayments = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardFiveAsync?schemeId=${encodeURIComponent(
			schemeId,
		)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getEqualisationPensions = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardSixAsync?schemeId=${encodeURIComponent(schemeId)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getEqualisationPensionsTwo = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardSevenAsync?schemeId=${encodeURIComponent(
			schemeId,
		)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getCalcTotalMembers = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardTotalMembersAsync?schemeId=${encodeURIComponent(
			schemeId,
		)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getCalcTotalMembersWithWarnings = (
	schemeId: string,
	token: string,
) =>
	instance.get(
		`/GetCalculationDashboardTotalMembersWithWarningsAsync?schemeId=${encodeURIComponent(
			schemeId,
		)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getCalcDate = (schemeId: string, token: string) =>
	instance.get(
		`/GetCalculationDashboardRunDateAsync?schemeId=${encodeURIComponent(
			schemeId,
		)}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const postGmpEqualisationReport = (schemeId: string, token: string) =>
	instance.post(
		`/api/GmpEqualisationReport/${schemeId}/gmp-equalisation-report?section=Calculation`,
		null,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getLatestGmpCalculationStatus = async (
	schemeId: number,
): Promise<AxiosResponse<string> | null> => {
	try {
		const response = await instance.get(
			`/GetLatestStatusGMPeCalculationRequest?schemeId=${schemeId}`,
		);
		return response;
	} catch (error) {
		console.error("Error fetching GMP calc status:", error);
		return null;
	}
};

export const getDashboardOne = (
	schemeId: number,
	version: string,
	token: string,
) =>
	instance.get(`/GetDashboardOneAsync`, {
		params: { schemeId, version },
		headers: { Authorization: `Bearer ${token}` },
	});

export const getDashboardTwo = (
	schemeId: number,
	type: string,
	token: string,
) =>
	instance.get(`/GetDashboardTwoAsync`, {
		params: { schemeId, type },
		headers: { Authorization: `Bearer ${token}` },
	});

export const getDashboardThree = (schemeId: number, token: string) =>
	instance.get(`/GetDashboardThreeAsync`, {
		params: { schemeId },
		headers: { Authorization: `Bearer ${token}` },
	});

export const getDashboardFour = (schemeId: number, token: string) =>
	instance.get(`/GetDashboardFourAsync`, {
		params: { schemeId },
		headers: { Authorization: `Bearer ${token}` },
	});

// export const getTotalMembers = (schemeId: number, token: string) =>
//   instance.get(`/GetTotalMembersAsync`, {
//     params: { schemeId },
//     headers: { Authorization: `Bearer ${token}` },
//   });

export const getScopingRunDate = (schemeId: number, token: string) =>
	instance.get(`/GetScopingChecksRunDateAsync`, {
		params: { schemeId },
		headers: { Authorization: `Bearer ${token}` },
	});

export const postScopingReportStatus = (schemeId: number, token: string) =>
	instance.post(
		`/api/GmpEqualisationReport/${schemeId}/gmp-equalisation-report?section=ScopingAssessment`,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getGmpDashboardOne = (
	schemeId: string,
	version: string,
	token: string,
) =>
	instance.get(
		`/GetGMPDVCDashboardOneAsync?schemeId=${schemeId}&version=${version}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getGmpDashboardTwo = (
	schemeId: string,
	type: string,
	token: string,
) =>
	instance.get(
		`/GetGMPDVCDashboardTwoAsync?schemeId=${schemeId}&type=${type}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getGmpDashboardThree = (
	schemeId: string,
	version: string,
	token: string,
) =>
	instance.get(
		`/GetGMPDVCDashboardThreeAsync?schemeId=${schemeId}&version=${version}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getGmpDashboardFour = (
	schemeId: string,
	version: string,
	token: string,
) =>
	instance.get(
		`/GetGMPDVCDashboardFourAsync?schemeId=${schemeId}&version=${version}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getGmpDashboardFive = (
	schemeId: string,
	version: string,
	token: string,
) =>
	instance.get(
		`/GetGMPDVCDashboardFiveAsync?schemeId=${schemeId}&version=${version}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getGmpDashboardSix = (
	schemeId: string,
	version: string,
	token: string,
) =>
	instance.get(
		`/GetGMPDVCDashboardSixAsync?schemeId=${schemeId}&version=${version}`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getTotalMembers = (schemeId: string, token: string) =>
	instance.get(`/GetTotalMembersAsync?schemeId=${schemeId}`, {
		headers: { Authorization: `Bearer ${token}` },
	});

export const getTotalMembersIn = (schemeId: string, token: string) =>
	instance.get(`/GetTotalMembersInAsync?schemeId=${schemeId}`, {
		headers: { Authorization: `Bearer ${token}` },
	});

export const getTotalMembersOut = (schemeId: string, token: string) =>
	instance.get(`/GetTotalMembersOutAsync?schemeId=${schemeId}`, {
		headers: { Authorization: `Bearer ${token}` },
	});

export const getTotalMembersUnknown = (schemeId: string, token: string) =>
	instance.get(`/GetTotalMembersUnknownAsync?schemeId=${schemeId}`, {
		headers: { Authorization: `Bearer ${token}` },
	});

export const getLastRunDate = (schemeId: string, token: string) =>
	instance.get(`/GetGMPDVCRunDateAsync?schemeId=${schemeId}`, {
		headers: { Authorization: `Bearer ${token}` },
	});

export const getDVCRunHistory = (schemeId: number, token: string | null) =>
	instance.get(`/GetDVCRunHistoryAsync?schemeId=${schemeId}&moduleId=1`, {
		headers: {
			Authorization: `Bearer ${token}`,
			Accept: "application/json",
		},
	});

export const getClientLogo = (clientId: number, token: string | null) =>
	instance.get(
		`/DownloadLatestFileForClientAsync?clientId=${clientId}&folderType=Logo`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				Accept: "application/json",
			},
			responseType: "blob",
		},
	);

export const postReadinessReportCompleted = (schemeId: string, token: string) =>
	instance.post(
		`/api/GmpEqualisationReport/${schemeId}/gmp-equalisation-report?section=DataReadinessAssessment`,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

export const getDataAuditReportDownload = async (
	schemeId: number,
	returnedReportId: any,
): Promise<AxiosResponse<Blob>> => {
	return instance.post(`/api/DataAuditReport/${schemeId}`, returnedReportId, {
		responseType: "blob",
	});
};

export const downloadGmpCalculationResults = async (
	schemeId: number,
	accessToken: string,
): Promise<Blob> => {
	const queryString = `schemeId=${encodeURIComponent(
		schemeId,
	)}&versionNumber=0`;

	const response = await instance.get(
		`/DownloadGMPeCalculationResults?${queryString}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
				Accept: "application/xlsm",
			},
			responseType: "blob",
		},
	);

	return response.data;
};

export const downloadCalcFileAsync = async (
	clientId: number,
	schemeId: number,
	accessToken: string,
	versionNumber: number | null
): Promise<Blob> => {
	const queryString = `clientId=${clientId}&schemeId=${schemeId}&folderType=GMPeCalculations&fileName=GMPe Calculation Tool - Version_${versionNumber}.xlsm`;

	const response = await instance.get(
		`/DownloadCalcFileAsync?${queryString}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
				Accept: "application/xlsm",
			},
			responseType: "blob",
		},
	);

	return response.data;
};

export const getMembersProcessedAsync = async (
	schemeId: number,
	runInstanceId: any,
): Promise<AxiosResponse> => {
	return instance.get(
		`/GetMembersProcessedAsync?schemeId=${schemeId}&runInstanceId=${runInstanceId}`,
	);
};

export const getGMPeCalculationResultsBySchemeID = async (
	schemeId: number,
): Promise<AxiosResponse> => {
	return instance.get(
		`/GetGMPeCalculationResultsBySchemeID?schemeId=${schemeId}`,
	);
};

export const getProformaCalculationsByMemberId = async (
	schemeId: number,
	memberId: string | number,
	accessToken: string,
): Promise<any> => {
	const queryString = `memberId=${encodeURIComponent(
		memberId,
	)}&schemeId=${encodeURIComponent(schemeId)}`;

	const response = await instance.get(
		`/GetProformaCalculationsResultByMemberId?${queryString}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	return response.data;
};

export const reRunScopingChecks = async (
	schemeId: number,
	accessToken: string,
	setConnectionTarget: Function
): Promise<any> => {

	setConnectionTarget("ScopingCheck")
	
	const url = `/AddAsync?schemeId=${schemeId}`;

	const payload = {
		schemeId: schemeId,
		versionNumber: null,
		withAssumptions: -1,
	};

	const response = await instance.post(url, payload, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			Accept: "application/json",
		},
	});

	return response.data;
};

export const callAddRunInstanceWithConfigAsync = async (
	schemeId: number,
	dvcObject: any,
	accessToken: string | null,
) => {
	const response = await instance.post(
		`/AddRunInstanceWithConfigAsync?schemeId=${schemeId}`,
		dvcObject,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
				"Content-Type": "application/json",
			},
		},
	);

	return response;
};

export const postReadinessAssessmentReport = async (
	schemeId: number,
	accessToken: string,
) => {
	const response = await instance.post(
		`/api/GmpEqualisationReport/${schemeId}/gmp-equalisation-report?section=ReadinessAssessment`,
		{},
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	return response;
};

export const getFromRunInstanceDVCAsync = async (
	schemeId: number,
	runInstanceId: number | null,
): Promise<AxiosResponse> => {
	return instance.get(
		`/api/DVCModuleOption/GetFromRunInstanceDVCAsync?schemeId=${schemeId}&runInstanceId=${runInstanceId}`,
	);
};

// ------------DATA MIGRATION START--------------------------------------------------------------------
export const getDataSource = async (tableMetadataId: string) => {
	return await dataMigrationInstance.get(
		"/api/TableMetadata/get-source-objects?tableId=" + tableMetadataId,
	);
};

export const getTableMetadata = async (clientId: number, schemeId: number) => {
	return await dataMigrationInstance.get(
		`/api/TableMetadata/list-table-metadata?clientId=${clientId}&schemeId=${schemeId}`,
	);
};

// Get all table names and columns
export const getTablesAndColumns = async (): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		"/api/PyxisGenericObject/get-all-generic-objects",
	);
};

// delete spreadsheet
export const deleteSpreadSheet = async (id: string): Promise<AxiosResponse> => {
	return await dataMigrationInstance.delete("/api/Spreadsheet/delete?id=" + id);
};

export const postArchiveTableMetadata = async (
	tableMetadataId: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.post(
		"/api/Archive?TableMetadataId=" + tableMetadataId,
	);
};

export const getArchivedTableMetadata = async (
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		`/api/Archive?clientId=${clientId}&schemeId=${schemeId}`,
	);
};

export const deleteUnarchiveTableMetadata = async (
	id: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.delete("/api/Archive/unarchive?id=" + id);
};

// Get mapping sets
export const getMappingSets = async (id: string): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		"/api/MappingSet/get-mapping-sets-for-table?tableMetadataId=" + id,
	);
};

// Get getDataTransfers
export const getDataTransfers = async (
	schemeId: number,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		"/api/DataTransfer/data-transfers-by-scheme?schemeId=" + schemeId,
	);
};

// Save mapping sets
export const postSaveMappingSet = async (
	mappings: any,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.post(
		"/api/MappingSet/save-mapping-set",
		mappings,
	);
};
// Save mapping set template
export const postSaveMappingSetTemplate = async (
	id: string | undefined,
	clientId: number,
	mappingSetId: string,
	templateName: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.post("/api/Template/save-template-mapping-set", {
		id,
		clientId,
		mappingSetId,
		templateName,
	});
};
// Get mapping set templates
export const getMappingsetTemplates = async (
	clientId: number,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		"/api/Template/get-template-mapping-sets-for-client?clientId=" + clientId,
	);
};

export const deleteMappingsetTemplate = async (
	templateMappingSetId: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.delete(
		"/api/Template/delete-template-mapping-set?templateMappingSetId=" +
			templateMappingSetId,
	);
};
//Run data transfer
export const postRunDataTransfer = async (
	mappingSetIds: string[],
	schemeId: number,
): Promise<AxiosResponse> => {
	const body = {
		schemeId,
		mappingSetIds,
	};

	return await dataMigrationInstance.post(
		"/api/DataTransfer/queue-data-transfer",
		body,
		{
			headers: {
				"Content-Type": "application/json",
			},
		},
	);
};

// Get mapping sets
export const postHandleUploadFile = async (
	clientId: number,
	schemeId: number,
	object: FormData,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.post(
		`/api/Spreadsheet/process?clientId=${clientId}&schemeId=${schemeId}`,
		object,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);
};
//  Delete mapping sets
export const deleteMappingSet = async (
	mappingSetId: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.delete(
		`/api/MappingSet/delete-mapping-set?mappingSetId=${mappingSetId}`,
	);
};

// Get edit client
export const getEditClient = async (id: string): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		"/api/MappingSet/load-mapping-set?mappingSetId=" + id,
	);
};

// Get edit client
export const postControlData = async (id: string): Promise<AxiosResponse> => {
	return await dataMigrationInstance.post("/api/ControlData/process?tableId=" + id);
};

// Get static data
export const getStaticData = async (
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		"/api/StaticValue/get-all-static-values?clientId=" +
			clientId +
			"&schemeId=" +
			schemeId,
	);
};

// Add and Edit static data
export const addEditStaticData = async (
	id: string | null,
	value: string | null,
	description: string | null,
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	const addUrl: string =
		"/api/StaticValue/save-static-value?Value=" +
		value +
		"&Description=" +
		description +
		"&ClientId=" +
		clientId +
		"&SchemeId=" +
		schemeId;
	const editUrl: string =
		"/api/StaticValue/save-static-value?Id=" +
		id +
		"&&Value=" +
		value +
		"&Description=" +
		description +
		"&ClientId=" +
		clientId +
		"&SchemeId=" +
		schemeId;
	return await dataMigrationInstance.post(id === null ? addUrl : editUrl);
};
// Delete static data
export const deleteStaticData = async (
	id: string | null,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.delete(
		"/api/StaticValue/delete-static-value?id=" + id,
	);
};
//Control totals
export const downloadControlTotalReport = async (
	dataTransferId: string,
): Promise<AxiosResponse<Blob>> => {
	return await dataMigrationInstance.get(
		"/api/ControlData/download-control-total-report?dataTransferId=" +
			dataTransferId,
		{
			responseType: "blob",
		},
	);
};
export const getReportTypesAsync = async (): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get("/api/ReportOutput/report-types");
};
export const queueReportSpreadsheet = async (
	dataTransferId: string,
	mappingSetId: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.post(
		"/api/ReportOutput/queue-report-spreadsheet",
		{ dataTransferId, mappingSetId },
		{
			headers: {
				"Content-Type": "application/json",
			},
		},
	);
};
export const downloadReportSpreadsheet = async (
	dataTransferId: string,
	mappingSetId: string,
): Promise<AxiosResponse<Blob>> => {
	return await dataMigrationInstance.get(
		"/api/ReportOutput/download-report-spreadsheet?dataTransferId=" +
			dataTransferId +
			"&mappingSetId=" +
			mappingSetId,
		{
			responseType: "blob",
		},
	);
};
export const downloadUntypedDataReport = async (
	schemeId: number,
	pyxisMemberDataTransferVersion: number,
): Promise<AxiosResponse<Blob>> => {
	return await instance.get(
		"/ExportUntypedData?schemeId=" +
			schemeId +
			"&versionNumber=" +
			pyxisMemberDataTransferVersion,
		{
			responseType: "blob",
		},
	);
};

export const saveTransformation = async (
	payload: any,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.post(
		"/api/Transformation/save-transformation",
		payload,
	);
};

export const deleteTransformation = async (
	id: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.delete(
		`/api/Transformation/delete-transformation?id=${id}`,
	);
};

export const getAllTransformationsForTable = async (
	tableMetadataId: string,
): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		`/api/Transformation/get-all-transformations-for-table?tableMetadataId=${tableMetadataId}`,
	);
};

export const getAllTransformationTypes = async (): Promise<AxiosResponse> => {
	return await dataMigrationInstance.get(
		"/api/TransformationType/get-all-transformation-types",
	);
};
// ------------DATA MIGRATION END--------------------------------------------------------------------

//get sentences from azure

export const getSentences = async (
	clientIdContext: any,
	schemeTypeContext: any,
	folderTypeForSentences: any,
): Promise<AxiosResponse> => {
	const queryString = `clientId=${clientIdContext}&schemeId=${schemeTypeContext}&folderType=${folderTypeForSentences}`;
	return await instance.get("/DownloadContainerContentsAsync?" + queryString, {
		headers: {
			accept: "application/octet-stream",
		},
		responseType: "blob",
	});
};

export const postSentences = async (
	clientIdContext: any,
	schemeTypeContext: any,
	folderType: any,
	containerTypePost: any,
	data: any,
): Promise<AxiosResponse> => {
	const queryString = `clientId=${clientIdContext}&schemeId=${schemeTypeContext}&folderType=${folderType}&containerType=${containerTypePost}`;
	return await instance.post(
		"/UploadFilesToContainerBlobAsync?" + queryString,
		data,
	);
};

// ------------DCS START--------------------------------------------------------------------

export const getDataAreas = async (): Promise<AxiosResponse> => {
	return await dcsInstance.get("/api/DataArea");
};

export const postDataArea = async (dataArea: {
	name: string;
}): Promise<AxiosResponse> => {
	return await dcsInstance.post("/api/DataArea/save", dataArea);
};

export const deleteDataArea = async (id: string): Promise<AxiosResponse> => {
	return await dcsInstance.delete(`/api/DataArea/${id}`);
};

export const getDataItemByDataAreaId = async (
	dataAreaId: string,
): Promise<AxiosResponse> => {
	return await dcsInstance.get(`/api/DataItem/area/${dataAreaId}`);
};

export const getKeySearchByDataItemId = async (
	dataItemId: string,
): Promise<AxiosResponse> => {
	return await dcsInstance.get(`/api/KeySearch/dataitem/${dataItemId}`);
};
export const getDCSProgress = async (
	containerName: string,
): Promise<AxiosResponse> => {
	return await dcsInstance.get(`/api/Progress/AI/${containerName}`);
};

export const downloadDcsProgressReport = async (
	locationMetadataId: string,
): Promise<AxiosResponse<Blob>> => {
	return await dcsInstance.get(
		"/api/curation/download-curation-results-for-location?locationMetadataId=" +
			locationMetadataId,
		{
			responseType: "blob",
		},
	);
};
// DCS SearchTerm API methods
export const saveSearchTerm = async (searchTermData: {
	id?: string;
	term: string;
	keySearchId: string;
}): Promise<AxiosResponse> => {
	return await dcsInstance.post("/api/SearchTerm/save", searchTermData);
};

export const deleteSearchTerm = async (
	termId: string,
): Promise<AxiosResponse> => {
	return await dcsInstance.delete(`/api/SearchTerm/${termId}`);
};

// DCS KeySearch API methods
export const saveKeySearch = async (keySearchData: {
	id?: string;
	name: string;
	priority: number;
	dataItemId: string;
}): Promise<AxiosResponse> => {
	return await dcsInstance.post("/api/KeySearch/save", keySearchData);
};

export const deleteKeySearch = async (
	keySearchId: string,
): Promise<AxiosResponse> => {
	return await dcsInstance.delete(`/api/KeySearch/${keySearchId}`);
};

// DCS DataItem API methods
export const saveDataItem = async (dataItemData: {
	id?: string;
	name: string;
	dataType: string;
	dataAreaId: string;
}): Promise<AxiosResponse> => {
	return await dcsInstance.post("/api/DataItem/save", dataItemData);
};

export const deleteDataItem = async (
	dataItemId: string,
): Promise<AxiosResponse> => {
	return await dcsInstance.delete(`/api/DataItem/${dataItemId}`);
};

// ORION AI

export const GetUnprocessedDocuments = async (
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	return await orionInstance.get(
		`/api/Documents/get-uploaded?clientId=${clientId}&schemeId=${schemeId}`,
	);
};

export const GetProcessedDocuments = async (
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	return await orionInstance.get(
		`/api/Documents/get-processed?clientId=${clientId}&schemeId=${schemeId}`,
	);
};

export const uploadUnprocessedDocuments = async (
	clientId: number,
	schemeId: number,
	formData: FormData,
): Promise<AxiosResponse> => {
	return await orionInstance.post(
		`/api/Documents/upload-unprocessed?clientId=${clientId}&schemeId=${schemeId}`,
		formData,
	);
};

export const getOrionDocuments = async (
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	return await orionInstance.get(
		`/api/Documents/get-uploaded?clientId=${clientId}&schemeId=${schemeId}`,
	);
};

export const downloadContainerContents = async (
	clientId: number,
	schemeId: number,
	folderType: string,
	accessToken: string | null,
): Promise<AxiosResponse> => {
	const queryString = `clientId=${encodeURIComponent(clientId)}&schemeId=${encodeURIComponent(schemeId)}&folderType=${encodeURIComponent(folderType)}`;
	return await instance.get(`/DownloadContainerContentsAsync?${queryString}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			Accept: "application/octet-stream",
		},
		responseType: "blob",
	});
};

export const readContainerContents = async (
	clientId: number,
	schemeId: number,
	folderType: string,
	accessToken: string,
): Promise<AxiosResponse> => {
	const queryString = `clientId=${encodeURIComponent(clientId)}&schemeId=${encodeURIComponent(schemeId)}&folderType=${encodeURIComponent(folderType)}`;
	return await instance.get(`/ReadContainerContentsAsync?${queryString}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});
};

export const uploadFilesToCont = async (
	clientId: number,
	schemeId: number,
	folderType: string,
	formData: FormData,
	accessToken: string,
): Promise<AxiosResponse> => {
	const queryString = `clientId=${clientId}&schemeId=${schemeId}&folderType=${folderType}`;
	return await instance.post(
		`/UploadFilesToContainerAsync?${queryString}`,
		formData,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);
};

export const uploadFilesToContainer = async (
	clientId: number,
	schemeId: number,
	folderType: string,
	containerType: string,
	formData: FormData,
	accessToken: string,
): Promise<AxiosResponse> => {
	const queryString = `clientId=${clientId}&schemeId=${schemeId}&folderType=${folderType}&containerType=${containerType}`;
	return await instance.post(
		`/UploadFilesToContainerBlobAsync?${queryString}`,
		formData,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);
};

export const uploadFilesToHiddenContainer = async (
	clientId: number,
	schemeId: number,
	containerType: string,
	formData: FormData,
	accessToken: string,
): Promise<AxiosResponse> => {
	const queryString = `clientId=${clientId}&schemeId=${schemeId}&containerFolderType=${containerType}`;
	return await instance.post(
		`/UploadFilesToHiddenContainerAsync?${queryString}`,
		formData,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);
};

export const triggerSchemeProcessing = async (
	clientId: number,
	schemeId: number,
	folderType: string,
	containerType: string,
	accessToken: string,
): Promise<AxiosResponse> => {
	const formData = new FormData();
	const queryString = `clientId=${clientId}&schemeId=${schemeId}&folderType=${folderType}&containerType=${containerType}`;
	return await instance.post(
		`/UploadFilesToContainerBlobAsync?${queryString}`,
		formData,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);
};

export const downloadProforma = async (
	clientId: number,
	schemeId: number,
	accessToken: string,
	folderType: string
): Promise<AxiosResponse> => {
	const queryString = `clientId=${encodeURIComponent(clientId)}&schemeId=${encodeURIComponent(schemeId)}&folderType=${encodeURIComponent(folderType)}`;
	return await instance.get(`/DownloadContainerContentsAsync?${queryString}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			Accept: "application/xlsm",
		},
		responseType: "blob",
	});
};

export const checkDownloadFolderAvailability = async (
	clientId: number,
	schemeId: number,
	accessToken: string,
	folderType: string
): Promise<AxiosResponse> => {
	const queryString = `clientId=${encodeURIComponent(clientId)}&schemeId=${encodeURIComponent(schemeId)}&folderType=${encodeURIComponent(folderType)}`;

	return await instance.get(`/DownloadContainerContentsAsync?${queryString}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			Accept: "application/xlsm",
			Range: "bytes=0-1",
		},
	});
};

export const queueDocumentConversion = async (
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	const body = {
		clientId,
		schemeId,
	};
	return await orionInstance.post(
		"/api/Processor/queue-document-conversion",
		body,
	);
};

export const processSchemes = async (
	clientId: number,
	schemeId: number,
): Promise<AxiosResponse> => {
	const body = {
		clientId,
		schemeId,
	};
	return await orionInstance.post(
		"api/Processor/queue-document-p1section-trigger",
		body,
	);
};

export const deleteOrionBlobs = async (
	clientId: number,
	schemeId: number,
	selectedBlobUrls: string[],
): Promise<AxiosResponse> => {
	return await instance.delete(
		`/api/CloudStorage/delete-blobs?clientId=${clientId}&schemeId=${schemeId}`,
		{
			data: selectedBlobUrls,
			headers: { "Content-Type": "application/json" },
		},
	);
};
